




import Vue from 'vue'

export default Vue.extend({
  name: 'InnerHtml',
  props: {
    html: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.activateLinks()
  },
  updated() {
    this.activateLinks()
  },
  beforeUpdate() {
    this.deactivateLinks()
  },
  beforeDestroy() {
    this.deactivateLinks()
  },
  methods: {
    activateLinks() {
      const links = this.$el.getElementsByTagName('a')
      ;[...links].forEach((link: any) => link.addEventListener('click', this.handleLink))
    },
    deactivateLinks() {
      const links = this.$el.getElementsByTagName('a')
      ;[...links].forEach((link: any) => link.removeEventListener('click', this.handleLink))
    },
    handleLink(e: any) {
      e.preventDefault()
      this.$emit('innerLinkClick', e)
    },
  },
})
